const { HttpLink, from } = require('@apollo/client');
const { Mixin } = require('@xingternal/hops');
class GraphQLLinkMixin extends Mixin {
  getApolloLink() {
    const hopsApolloLink = new HttpLink({
      uri: this.config.graphqlUri,
      fetch: this.options.fetch || this.fetch,
    });

    const links = this.options.graphql.links ?? [];

    return from([...links, hopsApolloLink]);
  }
}

module.exports = GraphQLLinkMixin;
